export enum SortType {
  Asc = 'asc',
  Desc = 'desc',
}

export enum SortMode {
  Circle = 1,
  Value = 0,
}

// echart类型枚举
export enum ChartType {
  // 柱状图
  Bar = 'bar',
  // 折线图
  Line = 'line',
  // 饼图
  Pie = 'pie',
}

// 下载配置的 数据计算方式 聚合、拆分
export enum CalcMethod {
  Aggregated = 'aggregated',
  Separate = 'separate',
}
